import React from 'react';
import SkeletonLoader, { SkeletonText, SkeletonImage, SkeletonInput } from './SkeletonLoader';
import './OrderSummarySkeleton.css';

const OrderSummarySkeleton = ({ showMobileHeader = false }) => {
  return (
    <div className="order-summary-skeleton">
      {/* Mobile Collapsible Header */}
      {showMobileHeader && (
        <div className="mobile-summary-header-skeleton">
          <div className="summary-toggle-skeleton">
            <SkeletonText width="160px" height="16px" />
            <SkeletonText width="80px" height="20px" />
          </div>
        </div>
      )}

      {/* Desktop Summary Content */}
      <div className="summary-content-skeleton">
        {/* Product Items */}
        <div className="product-items-skeleton">
          {/* Product 1 */}
          <div className="product-item-skeleton">
            <div className="product-image-wrapper-skeleton">
              <SkeletonImage size="64px" />
              <div className="product-badge-skeleton">
                <SkeletonLoader width="20px" height="20px" borderRadius="50%" />
              </div>
            </div>
            <div className="product-details-skeleton">
              <SkeletonText width="140px" height="14px" marginBottom="6px" />
              <SkeletonText width="100px" height="12px" marginBottom="6px" />
              <SkeletonText width="80px" height="12px" />
            </div>
            <div className="product-price-skeleton">
              <SkeletonText width="60px" height="16px" />
            </div>
          </div>

          {/* Product 2 */}
          <div className="product-item-skeleton">
            <div className="product-image-wrapper-skeleton">
              <SkeletonImage size="64px" />
              <div className="product-badge-skeleton">
                <SkeletonLoader width="20px" height="20px" borderRadius="50%" />
              </div>
            </div>
            <div className="product-details-skeleton">
              <SkeletonText width="160px" height="14px" marginBottom="6px" />
              <SkeletonText width="90px" height="12px" marginBottom="6px" />
              <SkeletonText width="80px" height="12px" />
            </div>
            <div className="product-price-skeleton">
              <SkeletonText width="60px" height="16px" />
            </div>
          </div>
        </div>

        {/* Discount Code Section */}
        <div className="discount-section-skeleton">
          <div className="discount-input-group-skeleton">
            <SkeletonInput style={{ flex: 1, height: '44px' }} />
            <SkeletonLoader
              width="80px"
              height="44px"
              borderRadius="5px"
              variant="button"
              style={{ marginLeft: '8px' }}
            />
          </div>
        </div>

        {/* Price Breakdown */}
        <div className="price-breakdown-skeleton">
          {/* Subtotal */}
          <div className="price-row-skeleton">
            <SkeletonText width="80px" height="14px" />
            <SkeletonText width="70px" height="14px" />
          </div>

          {/* Shipping */}
          <div className="price-row-skeleton">
            <SkeletonText width="90px" height="14px" />
            <SkeletonText width="70px" height="14px" />
          </div>

          {/* Tax */}
          <div className="price-row-skeleton">
            <SkeletonText width="60px" height="14px" />
            <SkeletonText width="60px" height="14px" />
          </div>

          {/* Total */}
          <div className="price-row-skeleton total-row-skeleton">
            <SkeletonText width="50px" height="18px" />
            <SkeletonText width="90px" height="20px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummarySkeleton;
